import { FC, useState, useEffect } from "react";
import { Grid } from "@mui/material";
import CustomTable from "../../components/common/CustomTable/CustomTable";
import { ModalConfirm } from "../../components/common/ModalConfirm/ModalConfirm";
import { ApiStatus } from "../../types/api/status";
import { CustomBackdrop } from "../../components/common/CustomBackdrop/CustomBackdrop";
import { Notice } from "../../types/slices/noticesType";
import { useNoticeStore } from "../../hooks/useNoticeStore";
import { CreateEditNoticeModal } from "./components/CreateEditNoticeModal";

const columns = [
  { type: "options", field: "options", label: "Opciones", align: "center" },
  { type: "text", field: "title", label: "TITULO", align: "center" },
  { type: "text", field: "author", label: "AUTOR", align: "center" },
  { type: "text", field: "date", label: "FECHA", align: "center" },
  { type: "text", field: "order", label: "ORDEN", align: "center" },
  {
    type: "text",
    field: "status",
    label: "ESTADO",
    format: (row) => (row.status ? "Activo" : "Inactivo"),
    align: "center",
  }
];

const NoticesView: FC = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [page, setPage] = useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = useState<number>(10);
  const [rowSelected, setRowSelected] = useState<Notice>({} as Notice);
  const [modalDeleteConfirm, setModalDeleteConfirm] = useState<boolean>(false);

  const {
    notices,
    statusNotices,
    openModal,
    getNotices,
    getNoticesSearch,
    setSelectedNotice,
    deleteNotice,
    setOpenModal,
    setEditNotice,
    changeIsEdit,
  } = useNoticeStore();
  
  useEffect(() => {
    setLoading(true);
    getNotices().then(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onAdd = () => {
    changeIsEdit(false);
    setOpenModal(true);
  };

  const onEdit = (rowSelected) => {
    changeIsEdit(true);
    setEditNotice(rowSelected);
    setOpenModal(true);
  };

  const onDelete = (rowSelected) => {
    setRowSelected(rowSelected);
    setModalDeleteConfirm(true);
  };

  const onDeleteConfirm = async () => {
    const response = await deleteNotice(rowSelected?.id || 0);
    if (response === true) {
      setSelectedNotice({} as Notice);
      setModalDeleteConfirm(false);
      getNotices();
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const onSearch = (value) => {
    if (value.length >= 1) {
      getNoticesSearch(value);
    }
    if (value.length === 0) {
      getNotices();
    }
  };

  return (
    <>
      {statusNotices === ApiStatus.FETCHING && <CustomBackdrop open={true} />}
      <Grid item xs={12}>
        <CustomTable
          title={"Noticias"}
          columns={columns}
          loading={loading}
          rows={notices || []}
          onRowClick={() => {}}
          hasOptions
          onAddFn={onAdd}
          onDelete={onDelete}
          onEdit={onEdit}
          onSearch={onSearch}
          rowsPerPage={rowsPerPage}
          page={page}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Grid>
      {modalDeleteConfirm && (
        <ModalConfirm
          open={modalDeleteConfirm}
          closeModal={() => {
            setModalDeleteConfirm(false);
          }}
          onCancel={() => {
            setModalDeleteConfirm(false);
          }}
          onConfirm={onDeleteConfirm}
          status={statusNotices}
        />
      )}
      {openModal && <CreateEditNoticeModal />}
    </>
  );

};

export default NoticesView;